import type React from 'react';
import FullscreenOverlay from '../../../../ui/FullscreenOverlay';
import { ShareButton, FavoriteButton } from '../../SocialActions';
import { ApplyButton, ContactButton, TourButton } from '../../ListingActions';
import { NeighborhoodSpokeContent } from './NeighborhoodSpokeContent';
import { footerButtonGroup, headerRight, spokeContainer } from './neighborhoodSpoke.styles';
import { NeighborhoodProvider, useNeighborhoodContextSafe } from '../context';

/**
 * NeighborhoodSpoke - FullscreenOverlay wrapper for mobile.
 *
 * Composes NeighborhoodSpokeContent with FullscreenOverlay Header/Body/Footer.
 * On desktop, NeighborhoodSpokeContent is rendered inside DetailPanel instead.
 *
 * Self-provides NeighborhoodProvider when rendered outside of one (e.g., when
 * triggered from ListingSummaryModule). Safe to nest because the provider uses
 * a singleton state manager.
 */
export const NeighborhoodSpoke = () => {
  const existingContext = useNeighborhoodContextSafe();

  const content = (
    <div className={spokeContainer} data-testid="neighborhood-spoke" role="dialog" aria-label="Neighborhood details">
      <FullscreenOverlay.Header
        title="Neighborhood"
        data-testid="neighborhood-spoke-header"
        actions={
          <div className={headerRight}>
            <ShareButton
              onClick={() => {
                /* TODO: Implement share functionality */
              }}
              aria-label="Share this listing"
            />
            <FavoriteButton
              onClick={() => {
                /* TODO: Implement favorite functionality */
              }}
              aria-label="Add this listing to favorites"
            />
          </div>
        }
      />

      <FullscreenOverlay.Body padding="edge-to-edge">
        <NeighborhoodSpokeContent />
      </FullscreenOverlay.Body>

      <FullscreenOverlay.Footer>
        <div className={footerButtonGroup} data-testid="neighborhood-spoke-footer">
          <ApplyButton onClick={() => {}} />
          <TourButton onClick={() => {}} />
          <ContactButton onClick={() => {}} />
        </div>
      </FullscreenOverlay.Footer>
    </div>
  );

  if (existingContext) {
    return content;
  }

  return <NeighborhoodProvider>{content}</NeighborhoodProvider>;
};
